var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',{staticStyle:{"width":"56.23529%","height":"388px"},attrs:{"title":"租客异常预警","loading":_vm.loading,"nodata":_vm.nodata}},[_c('div',{staticStyle:{"height":"336px"},attrs:{"id":"tenantAbnormalWarning"}})])}
var staticRenderFns = []

export { render, staticRenderFns }